var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('loading-overlay') : _vm._e(), _c('title-row', {
    attrs: {
      "title": _vm.page.title,
      "subtitle": _vm.page.subtitle,
      "breadcrumb-items": [{
        text: 'Kártyák',
        to: {
          name: 'CardList'
        }
      }, _vm.page.breadcrumbItem]
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.form.status.name_ === 'printReady' && _vm.showPrintIcon ? _c('title-row-button', {
          attrs: {
            "loading": _vm.saving
          },
          on: {
            "click": _vm.print
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-printer")]), _vm._v(" Nyomtatás ")], 1) : _vm._e(), _vm.form.status.name_ === 'active' ? _c('title-row-button', {
          attrs: {
            "loading": _vm.saving
          },
          on: {
            "click": _vm.suspend
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-account-clock")]), _vm._v(" Felfüggesztés ")], 1) : _vm._e(), _vm.form.status.name_ === 'active' || _vm.form.status.name_ === 'tempInactive' ? _c('title-row-button', {
          attrs: {
            "loading": _vm.saving
          },
          on: {
            "click": _vm.deactivate
          }
        }, [_c('v-icon', [_vm._v("mdi-account-off")]), _vm._v(" Végleges letiltás ")], 1) : _vm._e(), _vm.form.status.name_ === 'tempInactive' ? _c('title-row-button', {
          attrs: {
            "loading": _vm.saving
          },
          on: {
            "click": _vm.activate
          }
        }, [_c('v-icon', [_vm._v("mdi-account-reactivate")]), _vm._v(" Aktiválás ")], 1) : _vm._e(), _vm.form.status.name_ !== 'permInactive' ? _c('title-row-button', {
          attrs: {
            "loading": _vm.saving
          },
          on: {
            "click": _vm.save
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Mentés ")], 1) : _vm._e(), _vm.image && !_vm.newPhoto ? _c('title-row-button', {
          on: {
            "click": _vm.printCard
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-file-pdf-box")]), _vm._v(" PDF letöltése ")], 1) : _vm._e()];
      },
      proxy: true
    }])
  }), _c('v-card', {
    staticClass: "rounded-xl overflow-hidden",
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "align-tabs": "center",
      "color": "text--primary"
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "primary"
    }
  }), _c('v-tab', {
    key: "meta"
  }, [_vm._v(" Metaadatok ")]), !_vm.page.isNew ? _c('v-tab', {
    key: "parking"
  }, [_vm._v(" Parkolás ")]) : _vm._e(), !_vm.page.isNew ? _c('v-tab', {
    key: "assets"
  }, [_vm._v(" Eszközök ")]) : _vm._e(), !_vm.page.isNew ? _c('v-tab', {
    key: "access_log"
  }, [_vm._v(" Belépés napló ")]) : _vm._e(), !_vm.page.isNew ? _c('v-tab', {
    key: "system_log"
  }, [_vm._v(" Rendszer napló ")]) : _vm._e(), !_vm.page.isNew ? _c('v-tab', {
    key: "access_check"
  }, [_vm._v(" Hibakeresés ")]) : _vm._e(), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: "meta",
    attrs: {
      "transition": false
    }
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Kártya adatok")]), _c('v-card-text', [_c('v-masked-text-field', {
    attrs: {
      "label": "Kártyaszám",
      "mask": _vm.$config.inputMasks.cardNumber,
      "filled": ""
    },
    model: {
      value: _vm.form.card_number,
      callback: function ($$v) {
        _vm.$set(_vm.form, "card_number", $$v);
      },
      expression: "form.card_number"
    }
  }), _c('v-card', {
    staticClass: "px-4 mb-8 d-flex align-center",
    attrs: {
      "flat": "",
      "color": "muted"
    }
  }, [_c('v-switch', {
    staticClass: "py-2 my-2",
    attrs: {
      "label": "Aktív kártya",
      "hide-details": "",
      "inset": ""
    },
    model: {
      value: _vm.form.active,
      callback: function ($$v) {
        _vm.$set(_vm.form, "active", $$v);
      },
      expression: "form.active"
    }
  })], 1), _c('v-masked-text-field', {
    directives: [{
      name: "uppercase",
      rawName: "v-uppercase"
    }],
    attrs: {
      "label": "RFID",
      "mask": _vm.$config.inputMasks.rfId,
      "persistent-hint": "",
      "placeholder": "Érintse a kártyát az olvasóhoz",
      "filled": "",
      "error-messages": _vm.errors.rf_id,
      "hint": _vm.form.status.name_ && _vm.form.status.name_ !== 'printReady' ? 'Nem módosítható' : ''
    },
    model: {
      value: _vm.form.rf_id,
      callback: function ($$v) {
        _vm.$set(_vm.form, "rf_id", $$v);
      },
      expression: "form.rf_id"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Státusz",
      "value": _vm.form.status.name,
      "readonly": "",
      "hint": "Nem módosítható",
      "persistent-hint": "",
      "filled": ""
    }
  }), _vm.hasFeature('CARD_TEMPLATE') ? _c('v-autocomplete', {
    attrs: {
      "label": "Sablon",
      "items": _vm.cardTemplates,
      "item-text": "name",
      "item-value": "id",
      "readonly": _vm.form.status.name_ && _vm.form.status.name_ !== 'printReady',
      "error-messages": _vm.errors.template_id,
      "hint": _vm.form.status.name_ && _vm.form.status.name_ !== 'printReady' ? 'Nem módosítható' : '',
      "persistent-hint": "",
      "filled": ""
    },
    on: {
      "change": function ($event) {
        _vm.showPrintIcon = false;
      }
    },
    model: {
      value: _vm.form.template_id,
      callback: function ($$v) {
        _vm.$set(_vm.form, "template_id", $$v);
      },
      expression: "form.template_id"
    }
  }) : _vm._e()], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Birtokos adatok")]), _c('v-card-text', [_c('v-select', {
    attrs: {
      "label": "Birtokos típus",
      "items": [{
        text: 'Új birtokos létrehozása',
        value: 'new'
      }, {
        text: 'Létező birotokoshoz rendelés',
        value: 'existing'
      }],
      "filled": ""
    },
    model: {
      value: _vm.cardOwnerType,
      callback: function ($$v) {
        _vm.cardOwnerType = $$v;
      },
      expression: "cardOwnerType"
    }
  }), _vm.cardOwnerType === 'new' ? _c('card-owner-form', {
    attrs: {
      "card-owner": _vm.form.owner,
      "errors": _vm.errors.owner
    }
  }) : [_c('async-autocomplete', {
    attrs: {
      "label": "Név",
      "url": "card-owners/list",
      "item-value": "element_id",
      "item-text": "name",
      "array-property": "card_owners",
      "filled": "",
      "return-object": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "py-2"
        }, [_c('div', [_vm._v(_vm._s(item.name))]), _c('div', {
          staticClass: "caption"
        }, [_vm._v(_vm._s(item.email))])])];
      }
    }]),
    model: {
      value: _vm.form.owner,
      callback: function ($$v) {
        _vm.$set(_vm.form, "owner", $$v);
      },
      expression: "form.owner"
    }
  }), _c('card-owner-form', {
    attrs: {
      "card-owner": _vm.form.owner,
      "errors": _vm.errors.owner,
      "hide": ['name']
    }
  })]], 2)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Kártya előnézet")]), _c('v-card-text', [_c('div', {
    staticClass: "card-preview-wrapper"
  }, [_c('v-card', {
    staticClass: "rounded-xl card-preview",
    attrs: {
      "elevation": "10"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var hover = _ref2.hover;
        return [_c('div', {
          staticClass: "photo-area",
          on: {
            "click": function ($event) {
              _vm.cameraDialog = true;
            }
          }
        }, [_vm.image ? _c('img', {
          staticClass: "photo-image",
          attrs: {
            "src": _vm.image,
            "alt": "Kártya fotó"
          }
        }) : _c('v-icon', {
          staticClass: "photo-icon"
        }, [_vm._v(" " + _vm._s(hover ? 'mdi-camera-plus' : 'mdi-account-box') + " ")])], 1)];
      }
    }])
  }), _c('div', {
    staticClass: "name-area"
  }, [_c('span', {
    staticClass: "owner-name"
  }, [_vm._v(_vm._s(_vm.form.owner.name || 'NÉV'))])]), _c('div', {
    staticClass: "card-number-area"
  }, [_c('span', {
    staticClass: "card-number"
  }, [_vm._v(_vm._s(_vm.form.card_number || '0000 0000'))])])], 1)], 1)])], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "400px",
      "persistent": ""
    },
    model: {
      value: _vm.cameraDialog,
      callback: function ($$v) {
        _vm.cameraDialog = $$v;
      },
      expression: "cameraDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("Fénykép készítése")]), _c('v-card-text', [_c('Webcam', {
    ref: "camera",
    attrs: {
      "width": "350",
      "height": "420"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.createPhoto();
        _vm.cameraDialog = false;
      }
    }
  }, [_vm._v(" Fénykép készítése ")]), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.cameraDialog = false;
      }
    }
  }, [_vm._v("Mégse")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Hozzáférési szintek")]), _c('v-card-text', [_c('v-multi-select-list', {
    attrs: {
      "headers": [{
        text: 'Megnevezés',
        value: 'name'
      }, {
        text: 'Lejárat',
        value: 'valid_to'
      }],
      "items": _vm.accessLevels,
      "item-value": "element_id",
      "item-text": "name",
      "unique-values": "",
      "blank-item-template": {
        element_id: 0
      }
    },
    scopedSlots: _vm._u([{
      key: `item.name`,
      fn: function (_ref3) {
        var item = _ref3.item,
          items = _ref3.items;
        return [_c('v-autocomplete', {
          attrs: {
            "items": items,
            "item-text": "name",
            "item-value": "element_id",
            "placeholder": "Válassz",
            "hide-details": "",
            "filled": "",
            "dense": ""
          },
          model: {
            value: item.element_id,
            callback: function ($$v) {
              _vm.$set(item, "element_id", $$v);
            },
            expression: "item.element_id"
          }
        })];
      }
    }, {
      key: `item.valid_to`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('v-datetime-picker', {
          attrs: {
            "time-picker": false,
            "hide-details": "",
            "dense": "",
            "placeholder": "Nincs lejárat",
            "filled": ""
          },
          model: {
            value: item.valid_to,
            callback: function ($$v) {
              _vm.$set(item, "valid_to", $$v);
            },
            expression: "item.valid_to"
          }
        })];
      }
    }], null, true),
    model: {
      value: _vm.form.access_levels,
      callback: function ($$v) {
        _vm.$set(_vm.form, "access_levels", $$v);
      },
      expression: "form.access_levels"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-tab-item', {
    key: "parking",
    attrs: {
      "transition": false
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Rendszámok")]), _c('v-card-text', [_c('v-multi-select-list', {
    attrs: {
      "headers": [{
        text: 'Rendszám',
        value: 'number'
      }],
      "items": _vm.form.plates,
      "item-value": "number",
      "item-text": "number",
      "hide-default-header": ""
    },
    scopedSlots: _vm._u([{
      key: `item.number`,
      fn: function (_ref5) {
        var item = _ref5.item,
          index = _ref5.index;
        return [_c('v-masked-text-field', {
          directives: [{
            name: "uppercase",
            rawName: "v-uppercase"
          }],
          attrs: {
            "label": `Rendszám ${index + 1}`,
            "error-messages": _vm.errors[`plate-${index}`],
            "filled": "",
            "dense": "",
            "hide-details": !item.active_season_ticket,
            "mask": _vm.$config.inputMasks.plateNumber
          },
          model: {
            value: item.number,
            callback: function ($$v) {
              _vm.$set(item, "number", $$v);
            },
            expression: "item.number"
          }
        })];
      }
    }], null, true),
    model: {
      value: _vm.form.plates,
      callback: function ($$v) {
        _vm.$set(_vm.form, "plates", $$v);
      },
      expression: "form.plates"
    }
  })], 1)], 1), _c('v-divider'), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Parkolási büntetések")]), _c('v-card-text', [_c('parking-penalties')], 1)], 1)], 1), _c('v-tab-item', {
    key: "assets",
    attrs: {
      "transition": false
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', [_vm._v("Tulajdonodban")]), _vm.assets && _vm.assets.length ? _c('v-chip', {
    staticClass: "ml-2",
    attrs: {
      "small": "",
      "outlined": "",
      "color": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.assets.length) + " db ")]) : _vm._e()], 1)]), _c('v-card-text', [_vm.assets && _vm.assets.length ? _c('v-row', _vm._l(_vm.assets, function (asset) {
    return _c('v-col', {
      key: asset.id,
      attrs: {
        "cols": 12,
        "sm": 6,
        "md": 4,
        "lg": 3
      }
    }, [_c('v-card', {
      attrs: {
        "rounded": "lg",
        "flat": "",
        "outlined": ""
      }
    }, [_c('v-card-text', [_c('div', {
      staticClass: "d-flex align-center"
    }, [_c('v-sheet', {
      staticClass: "mr-3",
      attrs: {
        "color": asset.color || 'grey',
        "width": "4",
        "height": "32",
        "rounded": ""
      }
    }), _c('div', {
      staticClass: "flex-grow-1"
    }, [_c('div', {
      staticClass: "font-weight-bold text-truncate"
    }, [_vm._v(" " + _vm._s(asset.name) + " ")])]), _vm.hasRight('KEY_WRITE') ? _c('v-btn', {
      attrs: {
        "icon": "",
        "small": "",
        "color": "primary",
        "to": {
          name: 'AssetEditor',
          params: {
            id: asset.id
          }
        },
        "title": "Szerkesztés"
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1)])], 1)], 1);
  }), 1) : _c('v-card', {
    staticClass: "pa-6",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticClass: "text--secondary"
  }, [_vm._v("Jelenleg nincs kulcs a tulajdonodban")])])], 1)], 1), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', [_vm._v("Összes kulcs")]), _vm.dataTable.itemsLength ? _c('v-chip', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary",
      "small": "",
      "outlined": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.dataTable.itemsLength) + " db ")]) : _vm._e()], 1)]), _c('v-card-text', [_c('v-row', {
    staticClass: "mb-2",
    attrs: {
      "justify": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": 12,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.$config.inputMasks.name,
      expression: "$config.inputMasks.name"
    }],
    staticClass: "search-field",
    attrs: {
      "label": "Keresés...",
      "dense": "",
      "clearable": "",
      "hide-details": "",
      "filled": "",
      "color": "primary"
    },
    on: {
      "input": _vm.searchEventHandler
    },
    model: {
      value: _vm.assetSearch.name,
      callback: function ($$v) {
        _vm.$set(_vm.assetSearch, "name", $$v);
      },
      expression: "assetSearch.name"
    }
  })], 1)], 1), _c('v-data-table', {
    staticClass: "rounded-lg",
    attrs: {
      "headers": _vm.dataTable.headers,
      "items": _vm.dataTable.items,
      "server-items-length": _vm.dataTable.itemsLength,
      "options": _vm.dataTable.options,
      "footer-props": _vm.$config.dataTableFooterProps,
      "elevation": "2"
    },
    on: {
      "update:options": [function ($event) {
        return _vm.$set(_vm.dataTable, "options", $event);
      }, _vm.fetchItems]
    },
    scopedSlots: _vm._u([{
      key: `item.name`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('v-sheet', {
          staticClass: "mr-2",
          attrs: {
            "color": `${item.color || 'grey'}`,
            "width": "8",
            "height": "24",
            "rounded": "sm"
          }
        }), _c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(item.name))])], 1)];
      }
    }, {
      key: `item.cabinets`,
      fn: function (_ref7) {
        var item = _ref7.item;
        return _vm._l(item.cabinets, function (cabinet) {
          return _c('v-chip', {
            key: cabinet.id,
            staticClass: "ma-1",
            attrs: {
              "label": "",
              "link": "",
              "small": "",
              "to": {
                name: 'AssetCabinetList',
                params: {
                  highlight: [cabinet.id]
                }
              }
            }
          }, [_vm._v(" " + _vm._s(cabinet.name) + " ")]);
        });
      }
    }, {
      key: `item.actions`,
      fn: function (_ref8) {
        var item = _ref8.item;
        return [_vm.hasRight('KEY_WRITE') ? _c('v-btn', {
          staticClass: "rounded-sm mr-1",
          attrs: {
            "text": "",
            "fab": "",
            "small": "",
            "dark": "",
            "color": "primary",
            "to": {
              name: 'AssetEditor',
              params: {
                id: item.id
              }
            },
            "title": "Szerkesztés"
          }
        }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1) : _vm._e()];
      }
    }], null, true)
  })], 1)], 1)], 1), _c('v-tab-item', {
    key: "access_log",
    attrs: {
      "transition": false
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Belépés napló")]), _c('v-card-text', [_c('access-log', {
    attrs: {
      "card-id": _vm.form.element_id
    }
  })], 1)], 1)], 1), _c('v-tab-item', {
    key: "system_log",
    attrs: {
      "transition": false
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Rendszer napló")]), _c('v-card-text', [_c('admin-log', {
    attrs: {
      "card-id": _vm.form.element_id,
      "access-levels": _vm.accessLevels,
      "card-statuses": _vm.cardStatuses
    }
  })], 1)], 1)], 1), _c('v-tab-item', {
    key: "access_check",
    attrs: {
      "transition": false
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Hibakeresés")]), _c('v-card-text')], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }